export default {
  metadata: {
    version: '1.0.0',
    id: 'stepper-dot-1.0.0',
    name: 'JDSHorizontalStepItem'
  },
  hierarchy: {
    'stepper-outer-container': [
      {
        'stepper-inner-container': [
          'start-jds_divider',
          'jds_stepper_dot',
          'end-jds_divider'
        ]
      },
      'label-jds-text'
    ]
  },
  base: {
    'stepper-outer-container': {
      'flex-direction': '{h_0}',
      'align-items': '{h_1}',
      'justify-content': '{h_2}',
      size: '{h_3}',
      gap: '{h_4}'
    },
    'stepper-inner-container': {
      'flex-direction': '{h_5}',
      width: '{h_6}',
      'align-items': '{h_7}',
      gap: '{h_8}'
    },
    'start-jds_divider': {
      pad: 'none',
      flex: 1,
      withLabel: false,
      hidden: false,
      opacity: '{h_11}'
    },
    'end-jds_divider': {
      pad: 'none',
      withLabel: false,
      hidden: false,
      flex: 1,
      opacity: '{h_12}'
    },
    'label-jds-text': {
      'font-family': '{text_91}',
      color: '{text_20}',
      'font-size': '{text_90}',
      'line-height': '{text_92}',
      'letter-spacing': '{text_93}',
      'font-weight': '{text_94}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'padding-right': '{h_9}',
      'padding-left': '{h_10}'
    }
  },
  variant: {
    state: {
      complete: {
        'end-jds_divider': {
          variant: 'stepper'
        },
        'start-jds_divider': {
          variant: 'stepper'
        }
      },
      active: {
        'start-jds_divider': {
          variant: 'stepper'
        }
      },
      disabled: {
        'stepper-outer-container': {
          disabled: true
        },
        jds_stepper_dot: {
          state: 'disabled'
        }
      }
    },
    direction: {
      start: {
        'end-jds_divider': {
          opacity: '{h_13}'
        }
      },
      end: {
        'start-jds_divider': {
          opacity: '{h_14}'
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      state: {
        type: 'JDSStepperDot.state',
        values: ['inactive', 'active', 'complete', 'disabled']
      },
      itemsType: {
        type: 'JDSStepperDot.itemsType',
        values: ['numbered', 'icon', 'dot']
      },
      direction: {
        values: ['both', 'start', 'end']
      }
    },
    data: {
      jds_stepper_dot: {
        index: {
          type: 'string',
          name: 'index'
        },
        icon: {
          type: 'icon',
          name: 'icon'
        },
        state: {
          type: 'JDSStepperDot.state',
          name: 'state'
        },
        itemsType: {
          type: 'JDSStepperDot.itemsType',
          name: 'itemsType'
        },
        activeState: {
          type: 'JDSStepperDot.activeState',
          name: 'activeState'
        }
      },
      'label-jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      }
    },
    a11y: {
      'stepper-outer-container': {
        properties: {
          role: {
            value: 'listitem'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-current': {
            name: 'ariaCurrent'
          }
        }
      }
    }
  }
};
